import * as React from 'react';

type Props = {
  page: number;
  pages: number;
  from: number;
  to: number;
  total: number;
  onPageChange: (page: number) => void;
  isDisabled?: boolean;
  minWidth?: number;
};

export const ClubProgrammePager: React.FC<Props> = ({
  page,
  pages,
  from,
  to,
  total,
  onPageChange,
  isDisabled = false,
  minWidth = 190
}) => {
  const canPrev = !isDisabled && page > 1;
  const canNext = !isDisabled && page < pages;

  return (
    <div className="btn-group" role="group" aria-label="Pagination">
      <button type="button" className="btn btn-outline-secondary" disabled={!canPrev} onClick={() => onPageChange(1)}>
        «
      </button>

      <button
        type="button"
        className="btn btn-outline-secondary"
        disabled={!canPrev}
        onClick={() => onPageChange(page - 1)}
      >
        ‹
      </button>

      <button type="button" className="btn btn-outline-secondary" disabled style={{ minWidth }}>
        {from} to {to} of {total}
      </button>

      <button
        type="button"
        className="btn btn-outline-secondary"
        disabled={!canNext}
        onClick={() => onPageChange(page + 1)}
      >
        ›
      </button>

      <button
        type="button"
        className="btn btn-outline-secondary"
        disabled={!canNext}
        onClick={() => onPageChange(pages)}
      >
        »
      </button>
    </div>
  );
};
